import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { GestionPageRoutingModule } from './gestion-routing.module';

import { GestionPage } from './gestion.page';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { ComponentModule } from 'src/app/components/components';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    GestionPageRoutingModule,
    DragDropModule,
    ComponentModule
  ],
  declarations: [GestionPage]
})
export class GestionPageModule { }